import type { AuthRepositoryInterface } from '../../domain/interfaces/AuthRepositoryInterface';
import type { RegisterData } from '@/types';
import type { UserEntity } from '../../domain/entities/User';

export class RegisterUseCase {
  constructor(private readonly authRepository: AuthRepositoryInterface) {}

  async execute(data: RegisterData): Promise<UserEntity> {
    return this.authRepository.register(data);
  }
}
